export const resolveLiqPayLanguage = (value?: string | null): 'uk' | 'en' => {
  const normalized = value?.trim().toLowerCase().split(/[-_]/)[0];
  return normalized === 'uk' ? 'uk' : 'en';
};
